// src/components/common/StatCard.js
import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const StatCard = ({ title, value, icon, color = "primary", trend, trendValue }) => {
  return (
    <Card sx={{ height: '100%', borderRadius: 3, transition: 'all 0.3s ease' }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{
            p: 1.5,
            bgcolor: `${color}.50`,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center'
          }}>
            {icon}
          </Box>
          {trend && (
            <Chip
              label={`${trend === 'up' ? '+' : '-'}${trendValue}%`}
              color={trend === 'up' ? 'success' : 'error'}
              size="small"
              icon={trend === 'up' ? <TrendingUp /> : <TrendingDown />}
            />
          )}
        </Box>
        <Typography variant="h4" fontWeight="700" gutterBottom>
          {value}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatCard;
